// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__htUFL","totalCount":"Pagination_totalCount__3a7-P"};